import api from './axios';

export const tratamientosService = {
  // Obtener todos los tratamientos
  getAll: () => api.get('/citas/tratamientos/'),
  
  // Obtener un tratamiento por ID
  getById: (id) => api.get(`/citas/tratamientos/${id}/`),
  
  // Crear un nuevo tratamiento
  create: (tratamiento) => api.post('/citas/tratamientos/', tratamiento),
  
  // Actualizar un tratamiento
  update: (id, tratamiento) => api.put(`/citas/tratamientos/${id}/`, tratamiento),
  
  // Eliminar un tratamiento
  delete: (id) => api.delete(`/citas/tratamientos/${id}/`),
};
